import React, { useEffect, useState } from "react";
import BluePlus from "../../../../../components/Images/BluePlus";
import Loader from "../../../../../components/Loader";
import LoadPrevious from "../../../../../components/LoadPrevious";
import PaginationDrawer from "../../../../../components/PaginationDrawer";
import { Popup } from "../../../../../components/Popup";
import { menuItemObj } from "../../../../../components/PrivatePage";
import { Box, Button, Text } from "../../../../../designSystem";
import { usePaginationNavigator } from "../../../../../lib/customHooks";
import { handleEventLog } from "../../../../../lib/utils";
import { ChapterContainer, ChapterHeader, DeleteHeader, DeleteMessage, PlusDiv, PopupCancelButton, PopupDeleteDraftButton, RightIcon, Tab, ChapterTabDiv } from "../../styles";
import Dustbin from "../../../../../components/Images/Dustbin";
import DraftChapter from "../draftChapter";
import NovelProgrammatic from "../Programmatic";
import { SortableComponent } from "../sortableNovel";
import { put, get } from "../../../../../lib/api";
import EmptyChapters from "../../Empty/emptyChapter";
import ChapterAudioSeriesTab from "./chapterAudioSeriesTab";
import AudiobookList from "./AudiobookList";

const tabs = [
    {
      name: "Draft",
      count: "4",
    },
    {
      name: "Published",
      count: "4",
    },
    {
      name: "Trash",
      count: "4",
    },
];

const ChaptersModule = ({ bookDetails, params, setNextUrl, prevUrl, setPrevUrl, chapters, isFetching, setChapters, fetchNovelDetail, ...props }) => {
    const {chapterLoader, setChapterLoader}= props
    const [deleteDraft, setDeleteDraft] = useState(false);
    const [selectedTab, setSelectedTab] = useState('chapters')
    const [restrictDelete, setRestrictDelete] = useState(false)
    const [deleteTrash, setDeleteTrash] = useState(false);
    const activeForApi = !params.tab ? "published" : params.tab;
    const active = params.tab || "published";
    const isAudioSeriesTabVisible = (bookDetails?.status === 'approved' || bookDetails?.status === 'published')
                                    && bookDetails?.application_status === 'ongoing' && bookDetails?.is_novel === 1
    const [chapterStatus, setChapterStatus] = useState({
        book_id: "",
        chapter_id: "",
        status: "",
        view: "dashboard",
    });
    const [statusTimeline, setStatusTimeline] = useState({
        entity_id: "",
        entity_name: "chapter",
        prev_status: "",
        next_status: "",
    });
    useEffect(() => {
      getChaptersByStatus()
    },[activeForApi])

    const id = bookDetails.book_id
    const {
        currentPaginationNo,
        setCurrentPaginationNo,
        episodeRange,
        handleEpisodeRangeData,
        episodesCount,
        setEpisodesCount,
        showPaginationDrawer,
        setShowPaginationDrawer,
        showPreviousLoader,
        setShowPreviousLoader,
        handlePaginationApiCall,
      } = usePaginationNavigator();

      const getChaptersByStatus = () => {
        if(bookDetails?.is_disabled)return
        setChapterLoader(true)
        let chapterStatusParams = {
          page_no: 1,
          book_id: id,
          status: activeForApi,
          view: "dashboard",
          is_novel: 1,
        }
        if(bookDetails?.is_novel === 2){
          chapterStatusParams = {...chapterStatusParams, is_ugc : 1}
        }
        get("/content_api/book.chapters_by_status", {
          params: chapterStatusParams,
        })
          .then((response) => {
            setChapters(response.results);
            setNextUrl(response.results.next_url);
            setEpisodesCount(response.results.chapter_count);
            handleEpisodeRangeData(response.results.chapter_count, "reverse");
            setChapterLoader(false)
          })
          .catch((err) => {
            setChapters([]);
            setChapterLoader(false);
            throw err;
          });
      };

    const hasRequiredBookDetails =
        bookDetails.image_url &&
        bookDetails.description &&
        bookDetails.book_title &&
        bookDetails.category_obj &&
        bookDetails.category_obj.topic_id;
    const shouldRedirectAfterEdit = bookDetails?.is_novel !== 2 && !hasRequiredBookDetails;

    const onTabClick = (tab) => {
      if (params.tab === "published" && tab.name === "Published") {
        setShowPaginationDrawer(true);
        return
      }
      props.history.push(
        `${menuItemObj.novels}/id/${id}?tab=${tab.name
          .replace(/\s/g, "-")
          .toLowerCase()}`
      ); 
    };


    const onPaginationRangeClick = (number) => {
        setShowPaginationDrawer(false);
        setNextUrl(null);
        handlePaginationApiCall(
          "/content_api/book.chapters_by_status",
          { page_no: number, book_id: id, status: activeForApi, view: "dashboard", is_novel: 1 },
          setChapterLoader,
          setPaginationRangeData
        );
      };
    
    const setPaginationRangeData = (response) => {
        const { next_url, prev_url } = response.results;
        setChapters(response.results);
        setNextUrl(next_url);
        setPrevUrl(prev_url);
    };
    const LoadPreviousPage = () => {
      handlePaginationApiCall(
        prevUrl,
        "{}",
        setShowPreviousLoader,
        setLoadPreviousData
      );
    };
    const setLoadPreviousData = (response) => {
      const { prev_url } = response.results;
      setChapters((prevState) => ({
        chapters: response.results.chapters.concat(prevState.chapters),
      }));
      setPrevUrl(prev_url);
      const prevNumber = prev_url
        ? Number(prev_url.split("page_no")[1].split("&")[0].slice(1)) + 1
        : 1;
      setCurrentPaginationNo(prevNumber);
    };

    const handleDelete = (e, view = "unset", chapter_id = "") => {
        e && e.stopPropagation();
        setDeleteDraft(!deleteDraft);
        if (view !== "unset") {
          setChapterStatus({
            ...chapterStatus,
            book_id: id,
            chapter_id: chapter_id,
            status: "trash",
          });
          setStatusTimeline({
            ...statusTimeline,
            entity_id: chapter_id,
            prev_status: view,
            next_status: "trash",
          });
        }
    };
    const deleteChapter = () => {
        put("/content_api/book.update_chapter_status?is_novel=1", {
          data: chapterStatus,
        }).then(() => {
          fetchNovelDetail();
          getChaptersByStatus();
          setDeleteDraft(false);
        }).catch((err)=> {
          if(bookDetails?.content_editing && err.code === 400){
            setRestrictDelete(true)
            setDeleteDraft(false)
          }
        })
    };

    const handleChapterRecover = (e, chapter_id) => {
        e.stopPropagation();
        put("/content_api/book.update_chapter_status?is_novel=1", {
          data: {
            chapter_id: chapter_id,
            status: "draft",
            book_id: id,
            view: "writers",
          },
        }).then(() => {
          fetchNovelDetail();
          getChaptersByStatus();
        });
    };

    const deleteTrashChapter = () => {
        get("/content_api/book.delete_chapter", {
          params: {
            chapter_id: chapterStatus.chapter_id,
            book_id: id,
            view: "dashboard",
            is_novel: 1,
          },
        }).then(() => {
          fetchNovelDetail();
          getChaptersByStatus();
          setDeleteTrash(!deleteTrash);
        });
    };

    const handleTrashDelete = (e, chapter_id = null) => {
        e && e.stopPropagation();
        if (chapter_id !== null) {
          setChapterStatus({
            ...chapterStatus,
            chapter_id: chapter_id,
            book_id: id,
          });
        }
        setDeleteTrash(!deleteTrash);
    };

    return(
        <>
          <PaginationDrawer
              show={showPaginationDrawer}
              close={() => setShowPaginationDrawer(false)}
              onPaginationRangeClick={onPaginationRangeClick}
              episodeRange={episodeRange}
              episodesCount={episodesCount}
              currentPaginationNo={currentPaginationNo}
              setCurrentPaginationNo={setCurrentPaginationNo}
              order='reverse'
          />
         
          <ChapterContainer>
            <ChapterTabDiv bg={!isAudioSeriesTabVisible && "var(--Dove)"}>
             {isAudioSeriesTabVisible ?
             <ChapterAudioSeriesTab selectedTab={selectedTab} setSelectedTab={setSelectedTab} /> : 
             <Text variant="heading">
                Chapters
              </Text>
              }
              {selectedTab === 'chapters' &&<Button variant="outlinePrimary" p={8} onClick={() => {
                handleEventLog('novel_detail','button_click',{route : window.location.pathname + window.location.search,button:'new_chapter'})
                props.history.push(
                    `${menuItemObj.novels}/add-chapter/${id}?proceed_to_details=${
                      shouldRedirectAfterEdit ? '1' : ''
                    }&count=${parseInt(bookDetails.stats.published_chapter_count)} &tab=${active}`
                  )}
                }>
                <PlusDiv>
                  <BluePlus />
                </PlusDiv>
                New Chapter
              </Button>}
            </ChapterTabDiv>
           

           {selectedTab === 'chapters' ? <>
              <Box
                variant="flexCard"
                position="sticky"
                top={50}
                p="16px"
                my={1}
                justifyContent="unset"
              >
                {tabs.map((tab, i) => {
                  return (
                    <Tab
                      key={i}
                      last={i === tabs.length - 1}
                      active={active.toUpperCase() === tab.name.toUpperCase()}
                      onClick={() => onTabClick(tab)}
                    >
                      <ChapterHeader>
                          {tab.name}&nbsp; 
                          {tab.name==='Published' && `(${bookDetails.stats?.published_chapter_count || 0})`}
                          {tab.name==='Draft' && bookDetails.stats?.draft_chapter_count > 0 && `(${bookDetails.stats.draft_chapter_count})`}
                          {tab.name==='Trash' && bookDetails.stats?.trash_chapter_count > 0 && `(${bookDetails.stats.trash_chapter_count})`}
                        {tab.name === "Published" && (
                          <RightIcon
                            active={active.toUpperCase() === tab.name.toUpperCase()}
                          ></RightIcon>
                        )}
                      </ChapterHeader>
                      {/* <UnderLine
                        active={active.toUpperCase() === tab.name.toUpperCase()}
                      /> */}
                    </Tab>
                  );
                })}
              </Box>
              {chapterLoader ? (
                <Loader />
              ) : chapters.chapters && chapters.chapters.length === 0 ? (
                <EmptyChapters status={active} />
              ) : active === "draft" && chapters.chapters ? (
                chapters.chapters.map((chapter, i) =>
                  chapter.status === "draft" || chapter.status === "published" ? (
                    <DraftChapter
                      key={chapter.chapter_id}
                      index={i}
                      chapter={chapter}
                      handleDraftDelete={handleDelete}
                      onClick={() =>
                        props.history.push(
                          `${
                            menuItemObj.novels
                          }/edit-chapter/${id}?chapter_id=${
                            chapter.chapter_id
                          }&proceed_to_details=${
                            shouldRedirectAfterEdit ? "1" : ""
                          }`
                        )
                      }
                    />
                  ) : (
                    ""
                  )
                )
              ) : (active === "published" || active === "chapters") &&
                chapters.chapters ? (
                <>
                  {prevUrl && (
                    <LoadPrevious
                      loadPreviousPage={LoadPreviousPage}
                      showPreviousLoader={showPreviousLoader}
                    ></LoadPrevious>
                  )}
                  <SortableComponent
                    chapters={chapters.chapters}
                    handleDelete={handleDelete}
                    handleDeleteCMS={handleTrashDelete}
                    updateChaptersList={getChaptersByStatus}
                    bookDetails={bookDetails}
                    id={id}
                    {...props}
                  />
                </>
              ) : active === "programmatic" && chapters.chapters ? (
                <NovelProgrammatic {...bookDetails}></NovelProgrammatic>
              ) : active === "trash" && chapters.chapters ? (
                chapters.chapters.map(
                  (chapter, i) =>
                    chapter.status === "trash" && (
                      <DraftChapter
                        key={chapter.chapter_id}
                        chapter={chapter}
                        handleTrashDelete={handleTrashDelete}
                        handleChapterRecover={handleChapterRecover}
                      />
                    )
                )
              ) : (
                ""
              )}
            </> : <AudiobookList bookId={bookDetails?.book_id}/>}
            
            {isFetching && <Loader />}
          </ChapterContainer>
          <Popup
            show={restrictDelete}
            close={() => setRestrictDelete(false)}
            renderActions={
              <>
                <PopupCancelButton
                  className="action-button"
                  type="button"
                  onClick={() => setRestrictDelete(false)}
                >
                  Close
                </PopupCancelButton>
              </>
            }
          >
            <DeleteMessage>
              To modify the chapters, please reach out to <a href = "mailto: writers@pocketfm.in">writers@pocketfm.in</a>, to support for the same along with book name & reason
            </DeleteMessage>
          </Popup>
          <Popup
              show={deleteDraft}
              close={handleDelete}
              renderActions={
              <>
                <PopupCancelButton
                  className="action-button"
                  type="button"
                  onClick={handleDelete}
                >
                  Cancel
                </PopupCancelButton>
                &nbsp;
                <PopupDeleteDraftButton
                  className="action-button"
                  type="button"
                  onClick={deleteChapter}
                >
                  Delete this chapter
                </PopupDeleteDraftButton>
              </>
              }
              >
              <Dustbin />
              <DeleteHeader>Delete this chapter?</DeleteHeader>
              <br />
              <DeleteMessage>
              Are you sure you want to delete this chapter, Deleting chapters
              moves it into the trash folder.
              </DeleteMessage>
          </Popup>
          <Popup
              show={deleteTrash}
              close={handleTrashDelete}
              renderActions={
              <>
                  <PopupCancelButton
                  className="action-button"
                  type="button"
                  onClick={handleTrashDelete}
                  >
                  Cancel
                  </PopupCancelButton>
                  &nbsp;
                  <Button variant="fillDanger" onClick={deleteTrashChapter}>
                  Delete Permanently
                  </Button>
              </>
              }
          >
              <Dustbin />
              <DeleteHeader>Delete this Chapter Permanently?</DeleteHeader>
              <br />
              <DeleteMessage>
              Are you sure you want to permanently delete this chapter, after
              deleting you won't be able to recover it.
              </DeleteMessage>
          </Popup>
        </>
    )
}

export default ChaptersModule